import { Wording } from '@/types';

export const LOVE_WORDING_EN: Wording = {
  components_header_media_content: 'Audios',
  components_header_media_1: 'Meditations',
  components_header_media_2: 'Podcast',
  components_header_text1: 'Guides',
  components_header_text2: 'Blog',
  components_header_members: 'Members',
  hero_text: 'Discover Love Through the Stars',
  hero_button_text: 'Begin Your Journey',
  components_ressources_section_title: 'LOVE & ASTROLOGY',
  components_ressources_subheader_text: 'Your Celestial Toolkit for Romantic Insight',
  components_ressources_span_text: 'Dive into our universe of podcasts and articles centered on love, zodiac compatibility, and cosmic connection. Whether you\'re searching for soulmate clarity or decoding your relationship patterns, our resources guide you to deeper understanding through the stars.',
  components_ressources_card_1_title: 'Zodiac Love Talks',
  components_ressources_card_1_text: 'Explore heartfelt podcast episodes delving into the emotional language of each sign, love compatibility, passion, and personal growth in relationships.',
  components_ressources_card_2_title: 'Love Blog',
  components_ressources_card_2_text: 'Read insights and reflections on how each sign loves, heals, and connects. From synastry to planetary romance, our blog is your guide to astrological love.',
  components_ressources_link: 'Explore Further',
  components_notes_and_google_title_1: 'Romantic Astrology',
  components_notes_and_google_title_2: 'Love Habits',
  components_notes_and_google_title_3: 'Listeners’ Love Reflections',
  components_review_google_text: 'What Our Listeners Say',
  media_content_section_title: 'LOVE & ZODIAC PODCAST',
  media_content_section_subheader_text: 'Real Talk on Cosmic Romance',
  text_media_1: 'Tune into deep, revealing episodes about astrological matches, emotional patterns, and romantic dynamics.',
  text_media_2: '',
  media_content_section_button_more: 'Listen Now',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: 'Astrological Love Stories & Insights',
  text2_section_button_more: 'Load More',
  components_text1_section_title: 'GUIDES',
  components_text1_subheader_text: '',
  components_text1_span_text: '',
  components_text1_card_1_title: '',
  components_text1_card_1_text: '',
  components_text1_card_3_title: '',
  components_text1_card_3_text: '',
  components_text1_card_2_title: '',
  components_text1_card_2_text: '',
  components_text1_link: '',
  components_footer_text: 'Let the Stars Guide Your Love Story',
  components_footer_info: 'Info',
  components_footer_registration_number: 'Registration number',
  components_footer_legal: 'Legal',
  components_footer_terms: 'Terms and Conditions',
  components_footer_privacy: 'Privacy Policy',
  button_load_more: 'Load More',
  page_media_2_content_hero_text: '',
  page_media_content_menu_antistress: '',
  page_media_content_menu_mindfulness: '',
  page_media_content_menu_energyboost: '',
  page_media_content_menu_mantra: '',
  page_media_1_content_hero_text: 'Love & Zodiac: Podcast Episodes',
  page_media_content_menu_compatibility: 'Compatibility',
  page_media_content_menu_love: 'Love',
  page_text1_hero_text: '',
  page_text1_section_title: '',
  page_text1_subheader_text: '',
  page_text2_hero_text: 'Explore Love Through Astrology',
  page_text2_section_title: 'Blog',
  page_text2_subheader_text: 'Articles',
  enter_email_title: 'Please enter your email to continue',
  enter_email_placeholder_email: 'Email',
  enter_email_button_enter: 'Enter',
  components_login_success_text: 'Login successful!',
  components_card_link_media_content: 'Listen Now',
  components_card_link_text2_content: 'Read Articles',
  components_card_link_text1_content: '',
  france: 'France',
  cyprus: 'Cyprus',
  tag_podcast: 'Podcast',
  tag_meditation: 'Meditation',
  page_media_content_menu_all: 'All',
};